import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBanner,
  ApiBannerGroupResponse,
  ApiBannerResponse,
  HomePromoBanner,
} from '@app/model/home-promo-banner.model';
import { parsePromoBannerStyle } from '@app/model/promo-banner-style.model';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HomePromoBannerDataService {
  private readonly apiUrl = environment.backendhost + '/api/bannerGroup';

  constructor(private http: HttpClient) {}

  getBanners(): Observable<HomePromoBanner[]> {
    return this.http
      .get<ApiBannerGroupResponse>(
        this.apiUrl + '?Page=1&PageSize=100'
      )
      .pipe(
        switchMap((response) => {
          const bannerGroup = response.data.collection.find(
            (group) =>
              group.is_active &&
              group.pageType === 1 &&
              group.pageLocationType === 2
          );

          if (!bannerGroup) {
            return of([]);
          }

          return this.http.get<ApiBannerResponse>(
            this.apiUrl +
              '/' +
              encodeURIComponent(bannerGroup.id) +
              '/banners'
          );
        }),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }

          return response.data
            .filter((banner) => banner.is_active)
            .sort(
              (firstBanner, secondBanner) =>
                (firstBanner.sort_order || 0) -
                (secondBanner.sort_order || 0)
            )
            .map((banner) => this.mapBanner(banner));
        }),
        catchError(() => of([]))
      );
  }

  private mapBanner(banner: ApiBanner): HomePromoBanner {
    const style = parsePromoBannerStyle(
      banner.add_info,
      'Xem thêm'
    );

    return {
      id: banner.id,
      title: banner.title || '',
      description: banner.description || '',
      buttonLabel: style.label,
      imageUrl: this.getImageUrl(banner.image),
      link: banner.link || '/blog',
      textColor: style.textColor,
      buttonBg: style.buttonBg,
      buttonText: style.buttonText,
      showTitle: style.showTitle,
      showDescription: style.showDescription,
      showButton: style.showButton,
    };
  }

  private getImageUrl(image: string | null): string {
    if (!image) {
      return '';
    }

    if (
      image.indexOf('http://') === 0 ||
      image.indexOf('https://') === 0
    ) {
      return image;
    }

    return environment.backendhost + image;
  }
}
